import styled from "styled-components";

const INK = "#14202b";
const BLUE_DEEP = "#2f4b63";
const BLUE_MID = "#4a7092";
const PEACH = "#fdad73";
const PEACH_DEEP = "#fd944d";
const EASE = "cubic-bezier(0.16, 1, 0.3, 1)";

/* ---------- Buttons (one radius rule: pill for every interactive element) ---------- */

export const PrimaryCta = styled.button`
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	white-space: nowrap;
	padding: 16px 34px;
	border: 0;
	border-radius: 999px;
	cursor: pointer;
	font-family: inherit;
	font-size: 16px;
	font-weight: 600;
	color: ${INK};
	background: linear-gradient(135deg, #ffc49b, ${PEACH} 55%, ${PEACH_DEEP});
	box-shadow:
		inset 0 1px 0 rgba(255, 255, 255, 0.55),
		0 14px 32px rgba(253, 148, 77, 0.35);
	transition:
		transform 0.35s ${EASE},
		box-shadow 0.35s ${EASE};

	svg {
		font-size: 20px;
		transition: transform 0.35s ${EASE};
	}

	&:hover {
		transform: translateY(-3px);
		box-shadow:
			inset 0 1px 0 rgba(255, 255, 255, 0.55),
			0 20px 40px rgba(253, 148, 77, 0.45);
		svg {
			transform: translateX(4px);
		}
	}
	&:active {
		transform: translateY(0) scale(0.98);
	}
`;

export const GhostCta = styled.a<{ $tone?: "light" | "dark" }>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	white-space: nowrap;
	padding: 15px 30px;
	border-radius: 999px;
	font-size: 16px;
	font-weight: 600;
	text-decoration: none;
	cursor: pointer;
	color: ${({ $tone }) => ($tone === "dark" ? INK : "#fff")};
	border: 1.5px solid ${({ $tone }) => ($tone === "dark" ? "rgba(20, 32, 43, 0.28)" : "rgba(255, 255, 255, 0.55)")};
	background: ${({ $tone }) => ($tone === "dark" ? "transparent" : "rgba(255, 255, 255, 0.08)")};
	backdrop-filter: blur(8px);
	-webkit-backdrop-filter: blur(8px);
	transition:
		background 0.3s ease,
		border-color 0.3s ease,
		transform 0.35s ${EASE};

	&:hover {
		background: ${({ $tone }) => ($tone === "dark" ? "rgba(20, 32, 43, 0.06)" : "rgba(255, 255, 255, 0.18)")};
		border-color: ${({ $tone }) => ($tone === "dark" ? INK : "#fff")};
		transform: translateY(-3px);
	}
	&:active {
		transform: translateY(0) scale(0.98);
	}
`;

/* ---------- Final CTA ---------- */

export const PageConversionWrapper = styled.section`
	padding: 48px 0 96px;

	.cta-panel {
		position: relative;
		isolation: isolate;
		overflow: hidden;
		border-radius: 48px;
		padding: clamp(48px, 8vw, 104px) clamp(24px, 6vw, 88px);
		color: #fff;
		background:
			radial-gradient(50% 70% at 100% 100%, rgba(253, 173, 115, 0.5), transparent 70%),
			radial-gradient(40% 60% at 0% 0%, rgba(255, 227, 227, 0.2), transparent 70%),
			linear-gradient(150deg, ${BLUE_DEEP}, ${BLUE_MID});
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 20px;
	}
	h2 {
		font-family: inherit;
		font-weight: 700;
		font-size: clamp(32px, 4.6vw, 60px);
		line-height: 1.06;
		letter-spacing: -0.035em;
		max-width: 16ch;
		text-wrap: balance;
	}
	p {
		font-size: 17px;
		line-height: 1.65;
		max-width: 50ch;
		color: rgba(255, 255, 255, 0.86);
	}
	.cta-actions {
		display: flex;
		flex-wrap: wrap;
		gap: 14px;
		margin-top: 12px;
	}

	${props => props.theme.breakpoints.down("md")} {
		padding: 24px 0 64px;
		.cta-panel {
			border-radius: 32px;
		}
	}
	${props => props.theme.breakpoints.down("sm")} {
		.cta-actions a,
		.cta-actions button {
			width: 100%;
		}
	}
`;

